import './App.scss';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import GFAHome from './pages/gfa-viewer';
import { useEffect, useState } from 'react';
import STBHome from './pages/stb-daily';
import FreidaMcFaddenHub from './pages/freida-mcfadden-hub';

function App() {

  const [darkMode, setDarkMode] = useState(() => {
      if ('theme' in localStorage) return localStorage.theme === 'dark';
      return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  function switchColourMode() {
      setDarkMode(prev => !prev);
  }

  useEffect(() => {
      localStorage.theme = darkMode ? 'dark' : 'light';
  }, [darkMode]);

  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home darkMode={darkMode} switchColourMode={switchColourMode} />} />
        <Route path='/gfa-viewer' element={<GFAHome darkMode={darkMode} />} />
        <Route path='/stb-daily' element={<STBHome darkMode={darkMode} />} />
        <Route path='/freida-mcfadden-hub' element={<FreidaMcFaddenHub darkMode={darkMode} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
